import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Nav from "./Nav";
import { fetchAllSales, deleteSales } from "./api";

const Allsales = () => {
  const nav = useNavigate();
  const queryClient = useQueryClient();
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch sales using React Query
  const { data: sales = [], isLoading } = useQuery({
    queryKey: ["allsales"],
    queryFn: fetchAllSales,
  });

  // Delete mutation
  const deleteMutation = useMutation({
    mutationFn: deleteSales,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["allsales"] }),
  });

  // Filtered sales based on search query
  const filteredSales = sales.filter((k) => {
    const cname = k[2] || "";
    const area = k[3] || "";
    const mobile = String(k[4] || "");
    const q = searchQuery.toLowerCase();
    return (
      cname.toLowerCase().includes(q) ||
      area.toLowerCase().includes(q) ||
      mobile.includes(searchQuery)
    );
  });

  const viewCustomer = (cid) => nav("/viewcustomer", { state: cid });
  const viewSales = (sid) => nav("/viewsales", { state: sid });

  return (
    <>
      <Nav />
      <div
        className="allsales-container"
        style={{ marginTop: "5%", padding: 20 }}
      >
        <NavLink className="nav-link" to="/sales">
          <button className="btn btn-success mb-3">Current Customer</button>
        </NavLink>
        <h3 className="mb-3">Completed Customer</h3>
        <input
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="form-control mb-3"
          placeholder="Search by Name, Area or Mobile"
        />

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sales ID</th>
                  <th>Customer ID</th>
                  <th>Name</th>
                  <th>Area</th>
                  <th>Mobile</th>
                  <th>Product</th>
                  <th>Sales Date</th>
                  <th>Day</th>
                  <th>Pay Date</th>
                  <th>Price</th>
                  <th>Balance</th>
                  <th>Payment Date</th>
                  <th>Change Date</th>
                  <th>Status</th>
                  <th>Last Pay</th>
                  {window.localStorage.getItem("pro") === "salman" && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {filteredSales.map((d) => (
                  <tr key={d[0]}>
                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => viewSales(d[0])}
                      >
                        {d[0]}
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => viewCustomer(d[1])}
                      >
                        {d[1]}
                      </button>
                    </td>
                    <td>{d[2]}</td>
                    <td>{d[3]}</td>
                    <td>{d[4]}</td>
                    <td>{d[5]}</td>
                    <td>{d[6]}</td>
                    <td>{d[7]}</td>
                    <td>{d[8]}</td>
                    <td>{d[9]}</td>
                    <td>{d[10]}</td>
                    <td>{d[11]}</td>
                    <td>{d[12]}</td>
                    <td>{d[13]}</td>
                    <td>{d[14]}</td>
                    {window.localStorage.getItem("pro") === "salman" && (
                      <td>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => deleteMutation.mutate(d[0])}
                          disabled={deleteMutation.isLoading}
                        >
                          {deleteMutation.isLoading ? "Deleting..." : "Delete"}
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Allsales;
